import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Siddha Mala", href: "#siddha-mala" },
  { label: "Shravan Pujas", href: "#shravan-pujas" },
  { label: "Exhibition", href: "#exhibition-hero" },
  { label: "Combo Kits", href: "#combo-kits" },
  { label: "Rare Collection", href: "#rare-collection" },
  { label: "Trusted Seekers", href: "#trusted" },
  { label: "Blogs", href: "#blogs" },
];

const Header = ({ brand = "Rudralife", tagline = "Rudraksha power for you", logo = "" }) => {
  const [logoOk, setLogoOk] = useState(true);
  const [open, setOpen] = useState(false);
  const showImage = logo && logoOk;

  const handleNav = (href) => {
    setOpen(false);
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      }
    }
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAF6F0]/95 border-b border-[rgba(45,40,37,0.08)] shadow-[0_2px_8px_rgba(45,40,37,0.03)]">
      <div className="max-w-7xl mx-auto px-4 md:px-10 h-16 md:h-20 flex items-center justify-between">
        {/* Logo */}
        <Link
          to="/"
          data-testid="nav-brand"
          data-cursor="button"
          className="flex items-center gap-3 flex-shrink-0"
        >
          {showImage ? (
            <img
              src={logo}
              alt={brand}
              onError={() => setLogoOk(false)}
              className="h-10 md:h-14 w-auto object-contain"
            />
          ) : (
            <div className="flex items-center gap-3">
              <div
                className="w-11 h-11 rounded-full flex items-center justify-center text-[#FAF6F0] font-serif text-xl"
                style={{ background: "radial-gradient(circle at 30% 30%, #b46a2a, #6b2f0a 70%, #2a1005)" }}
              >
                ॐ
              </div>
              <div className="leading-none">
                <div className="font-serif text-xl md:text-2xl tracking-tight text-[#6B1A1A]">{brand}</div>
                <div className="text-[9px] md:text-[10px] tracking-[0.15em] italic text-[#5C544F] mt-1">{tagline}</div>
              </div>
            </div>
          )}
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6 text-[11px] tracking-[0.25em] uppercase text-[#2D2825] font-medium">
          {NAV_LINKS.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-cursor="button"
              onClick={(e) => { e.preventDefault(); handleNav(n.href); }}
              className="hover:text-[#8B2323] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* Mobile hamburger */}
        <button
          type="button"
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
          data-cursor="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden flex items-center justify-center w-11 h-11 rounded-full bg-[#8B2323] text-white hover:bg-[#6B1A1A] transition-colors"
        >
          {open ? <X size={20} /> : <Menu size={22} strokeWidth={2.5} />}
        </button>
      </div>

      {/* Mobile Slide-out Menu */}
      {open && (
        <>
          <div
            className="lg:hidden fixed inset-0 top-16 bg-black/40 backdrop-blur-sm z-40"
            onClick={() => setOpen(false)}
          />
          <div
            data-testid="mobile-menu-panel"
            className="lg:hidden fixed top-16 left-0 right-0 z-50 bg-[#FAF6F0] border-b border-[rgba(45,40,37,0.1)] shadow-xl animate-slide-down"
          >
            <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-1">
              {NAV_LINKS.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  data-testid={`mobile-nav-${n.href.replace("#", "")}`}
                  data-cursor="button"
                  onClick={(e) => { e.preventDefault(); handleNav(n.href); }}
                  className="block px-4 py-3.5 rounded-xl text-sm tracking-[0.15em] uppercase text-[#2D2825] font-medium hover:bg-[#8B2323] hover:text-white transition-colors border border-transparent hover:border-[#8B2323]"
                >
                  {n.label}
                </a>
              ))}
            </nav>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
